import { FormEvent, useCallback, useContext, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container'; import { Stack } from '@mui/material';
import Copyright from '@/components/Copyright';
import { AppContext } from '@my-helpers/common'; import { themeOptions } from '@/utils/themeHelpers';
import { Notification } from '@/components/Notification';

export default function SignIn() {
	const app = useContext(AppContext);
	if (!app) {
		throw new Error('useAppContext must be used within an AppProvider');
	}
	const { isLoading, error, sessionUser, device } = app.view;
	const { signIn, clearError } = app.command;
	const location = useLocation();
	const navigate = useNavigate();

	const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		const data = new FormData(event.currentTarget);
		await signIn(
			data.get('email') as string,
			data.get('password') as string,
			device
		);
	}

	if (sessionUser) {
		if (sessionUser.emailVerified) {
			navigate(location.state?.path || "/");
		} else {
			navigate('/verify');
		}
	}

	return (
		<Container component="main" maxWidth="xs">
			<Box sx={{
				marginTop: 8,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center'
			}} >
				<Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
					<LockOutlinedIcon />
				</Avatar>
				<Typography component="h1" variant="h5">
					Sign in
				</Typography>
				<Box
					component="form"
					onSubmit={handleSubmit}
					noValidate
					sx={{ mt: 1 }} >
					<TextField
						margin="normal"
						required
						fullWidth
						id="email"
						label="Email Address"
						name="email"
						autoComplete="email"
						autoFocus
					/>
					<TextField
						margin="normal"
						required
						fullWidth
						name="password"
						label="Password"
						type="password"
						id="password"
						autoComplete="current-password" />
					<FormControlLabel
						control={<Checkbox value="remember" color="primary" />}
						label="Remember me" />
					<Button
						type="submit"
						fullWidth
						variant="contained"
						sx={{ mt: 3, mb: 2 }}>
						Sign In
					</Button>
					<Stack spacing={1}>
						<Link href="#" variant="body2">
							Forgot password?
						</Link>
						<Link href={"/signup"} variant="body2">
							{'Don\'t have an account? Sign Up'}
						</Link>
					</Stack>
				</Box>
			</Box>
			<Copyright sx={{ mt: 6, mb: 4 }} />
			<Notification
				isLoading={isLoading}
				error={error}
				clearError={clearError}
				delay={300}
				autoHideDuration={1200}
			/>
		</Container>
	)
}
